import config from "../../config";

const state = {
    usersCount: 0,
    roomId: config.ROOM_ID
}

const getters = {
    getUsersCount(state) {
        return state.usersCount
    },
    getRoomId (state) {
        return state.roomId
    }
}

const mutations = {
    setUsersCount(state, count) {
        state.usersCount = count
    },
    setRoomId(state, roomId) {
        state.roomId = roomId
    }
}

const actions = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
